import { render } from "./LabelWithHelp.vue?vue&type=template&id=d52fc484"
import script from "./LabelWithHelp.vue?vue&type=script&lang=js"
export * from "./LabelWithHelp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__